import { create } from 'zustand';

import { LOCAL_STORAGE_TOKEN_KEY } from '../common/constants';
import AuthenticationService from '../services/AuthenticationServices';
import { ILoginProps } from '../types/login-props-type';
import { IUser } from '../types/user-type';

interface IUserState {
	user: Partial<IUser> | undefined;
	usersAdmin: any;
	setUser: (newUser: Partial<IUser>) => void;
	logout: () => void;
	login: (props: ILoginProps) => Promise<void>;
	retrieveUser: () => Promise<void>;
	saveOneSignalId: (oneSignalToken: string) => Promise<void>;
	getAdminUser: () => Promise<any>;
}

export const useUserStore = create<IUserState>()((set) => ({
	user: undefined,
	usersAdmin: [],
	setUser: (newUser) => set({ user: newUser }),
	login: async ({ username, password }) => {
		const response = await AuthenticationService.login({
			username,
			password,
		});
		localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
		set({ user: response.data });
	},
	logout: async () => {
		try {
			if (localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY))
				await AuthenticationService.logout(localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY));
		} catch (error) {
			console.error('Errore durante il logout:', error);
		} finally {
			// Resetta lo stato e rimuovi i dati dal localStorage
			set({ user: undefined });
			localStorage.clear();
		}
	},
	retrieveUser: async () => {
		const jwtToken = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
		if (!jwtToken) {
			throw new Error('NO_JWT_PROVIDED');
		}
		const response = await AuthenticationService.retrieveCustomer(jwtToken);
		set({ user: response.data });
	},
	saveOneSignalId: async (oneSignalToken: string) => {
		await AuthenticationService.saveOneSignalId(oneSignalToken);
	},
	getAdminUser: async () => {
		const response = await AuthenticationService.getAdminUser();
		set({ usersAdmin: response });
		return response;
	},
}));
